import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Batch 12 Category Discover CTA Interspersed
 */
export const FE_BATCH_12_CATEGORY_DISCOVER_CTA_INTERSPERSED_081225 = experiment(
  {
    name: "FE_BATCH_12_CATEGORY_DISCOVER_CTA_INTERSPERSED_081225",
    identifier: "SessionToken",
    client: ["RETAILER", "VISITOR_WEB"],
    notifyAfter: "2025-11-25", // 3 months from today
    defaultValue: IThreeVariantXP.Bucket.CONTROL,
    productArea: "LOGGED_OUT_RETAILERS",
  }
);
